module.exports = __webpack_public_path__ + "static/media/Limonada de Fresa con Té de Limón.f87ad22a.webp";